var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_vm._v(" "),_c('ModalImageGallery',{attrs:{"open":_vm.modalOpen,"images":_vm.images,"labelled-by":_vm.labelledBy},on:{"update:open":function($event){_vm.modalOpen=$event}}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }